export const blockIconsContentFilterList = (
	<span className='material-symbols-outlined'>filter_list</span>
);
